/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */
(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener("theme:variant:change", function (event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log("Container ———————— ↓");
      console.log(container);
      console.log("Variant —————————— ↓");
      console.log(variant);
      // ... update some element on the page
    }
  });
  document.addEventListener("theme:cart:reload", function (e) {
    console.log("✅ Event 'theme:cart:reload' dispatched successfully!", e);
    var cartCheckInterval_bundles = setInterval(function () {
      var $bundlesDiscountElem = document.querySelector(
        ".docapp-coupon-input--bean-container--bean .docapp-coupon-input--bean-container--bean-remove"
      );

      var inputField = document.querySelector(".docapp-coupon-input--input");

      if ($bundlesDiscountElem) {
        var dataCode = $bundlesDiscountElem.getAttribute("data-code");

        if (dataCode && dataCode.trim().toUpperCase() === "BUNDLES") {
          console.log('Valid "BUNDLES" code found.');

          if (inputField) {
            inputField.value = dataCode;
            inputField.dispatchEvent(new Event("input", { bubbles: true }));

            var applyButton = document.querySelector(
              ".docapp-coupon-input--button"
            );
            if (applyButton) {
              applyButton.click();
                
            } else {
              console.warn("Apply button not found.");
            }
          } else {
            console.warn("Input field not found.");
          }

          clearInterval(cartCheckInterval_bundles);
        } else {
          console.log('No valid "BUNDLES" discount code found.');
          if (inputField) {
            inputField.value = "";
            inputField.dispatchEvent(new Event("input", { bubbles: true }));
            console.log("1 Input field cleared.");
          }
        }
      }
    }, 100);
  });
  // Original event listener for 'theme:cart:change'
  document.addEventListener("theme:cart:change", function (event) {
    var cart = event.detail.cart;
    console.log("cart updated initially..");
    if (cart && cart.items && cart.items.length > 0) {
      console.log("Cart Items ———————————— ↓");
      var cartCheckInterval_bundles = setInterval(function () {
        var $bundlesDiscountElem = document.querySelector(
          ".docapp-coupon-input--bean-container--bean .docapp-coupon-input--bean-container--bean-remove"
        );

        var inputField = document.querySelector(".docapp-coupon-input--input");

        if ($bundlesDiscountElem) {
          var dataCode = $bundlesDiscountElem.getAttribute("data-code");

          if (dataCode && dataCode.trim().toUpperCase() === "BUNDLES") {
            console.log('Valid "BUNDLES" code found.');

            if (inputField) {
              inputField.value = dataCode;
              inputField.dispatchEvent(new Event("input", { bubbles: true }));

              var applyButton = document.querySelector(
                ".docapp-coupon-input--button"
              );
              if (applyButton) {
                applyButton.click();
                console.log("Apply button clicked.");
                document.dispatchEvent(
                  new CustomEvent("theme:cart:reload", { bubbles: true })
                );
              } else {
                console.warn("Apply button not found.");
              }
            } else {
              console.warn("Input field not found.");
            }

            clearInterval(cartCheckInterval_bundles);
          } else {
            console.log('No valid "BUNDLES" discount code found.');
            if (inputField) {
              inputField.value = "";
              inputField.dispatchEvent(new Event("input", { bubbles: true }));
              console.log("2 Input field cleared.");
            }
          }
        }
      }, 100);

      cart.items.forEach(function (item, index) {
        // Uncomment to log item details
        // console.log("Item #" + (index + 1));
        // console.log("Title:", item.title);
        // console.log("Quantity:", item.quantity);
        console.log("Variant ID:", item.variant_id);
        // You can add more item-specific logic here
      });
    } else {
      // If the cart is empty
      console.log("🛒 Cart is empty.");
      console.log("length get" + $(".cart--hidden").length);
      var cartCheckInterval = setInterval(function () {
        var $cartEmptyElement = $(".myCartNew [data-cart-empty]");

        if ($cartEmptyElement.length > 0) {
          $cartEmptyElement
            .removeClass("cart--hidden")
            .addClass("cart-has-items");
          setTimeout(function () {
            $(".cart-has-items").removeClass("cart--hidden");
            document.dispatchEvent(
              new CustomEvent("theme:cart:reload", { bubbles: true })
            );
            console.log("length get" + $(".cart--hidden").length);
          }, 600);

          clearInterval(cartCheckInterval);
        }
      }, 10);
    }
  });

  // Fired when page loads to update header values
  document.addEventListener("theme:cart:init", (e) => {
    console.log("theme:cart:init");
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener("theme:scroll", (e) => {
    console.log(e);
    const buttonAddToCart = document.querySelector('.product-page product-add-button');
    const scrollToTop = document.querySelector('.back-to-top-section');
    const saleOffBanner = document.querySelector('.kl-teaser-TcszEA');
    const wishlistIcon = document.querySelector('.boFPdD');
    if (buttonAddToCart && scrollToTop) {
      if (buttonAddToCart.getBoundingClientRect().bottom <= e.detail.position) {
        scrollToTop.style.visibility = 'visible'
        if (wishlistIcon) {
          wishlistIcon.style.bottom = '144px';
        }
        if (saleOffBanner) {
          saleOffBanner.style.bottom = '104px';
        }
      } else {
        scrollToTop.style.visibility = 'hidden'
        if (wishlistIcon) {
          wishlistIcon.style.bottom = '40px';
        }
        if (saleOffBanner) {
          saleOffBanner.style.bottom = '0';
        }
      }
    }
  });
  document.addEventListener("theme:scroll:up", (e) => {
    console.log(e);
  });
  document.addEventListener("theme:scroll:down", (e) => {
    console.log(e);
  });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener("theme:resize", (e) => {
    console.log(e);
  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
$("body").on("click", ".custom_main_cart", function (e) {
  e.preventDefault();
  var getLength = $(".free_product").length;
  console.log("getLength" + getLength);
  if (getLength > 0) {
    jsonObj = [];
    var product_var = $(".free_product").val();

    item = {};
    item["id"] = parseInt(product_var);
    jsonObj.push(item);
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { items: jsonObj },
      dataType: "json",
      async: false,
      success: function (data) {
        console.log("data");

        $(".main_cart_btn").trigger("click");
        // const body = document.querySelector(".main_cart_btn");
        //body.dispatchEvent(new Event("click"));
        document.dispatchEvent(
          new CustomEvent("theme:cart:reload", { bubbles: true })
        );
        setTimeout(function () {
          
          var cartCheckInterval_bundles = setInterval(function () {
          var $bundlesDiscountElem = document.querySelector(
            ".docapp-coupon-input--bean-container--bean .docapp-coupon-input--bean-container--bean-remove"
          );

          var inputField = document.querySelector(".docapp-coupon-input--input");

          if ($bundlesDiscountElem) {
            var dataCode = $bundlesDiscountElem.getAttribute("data-code");

            if (dataCode && dataCode.trim().toUpperCase() === "BUNDLES") {
              console.log('Valid "BUNDLES" code found.');

              if (inputField) {
                inputField.value = dataCode;
                inputField.dispatchEvent(new Event("input", { bubbles: true }));

                var applyButton = document.querySelector(
                  ".docapp-coupon-input--button"
                );
                if (applyButton) {
                  applyButton.click();
                  console.log("Apply button clicked.");
                  document.dispatchEvent(
                    new CustomEvent("theme:cart:reload", { bubbles: true })
                  );
                } else {
                  console.warn("Apply button not found.");
                }
              } else {
                console.warn("Input field not found.");
              }

              clearInterval(cartCheckInterval_bundles);
            } else {
              console.log('No valid "BUNDLES" discount code found.');
              if (inputField) {
                inputField.value = "";
                inputField.dispatchEvent(new Event("input", { bubbles: true }));
                console.log("3 Input field cleared.");
              }
            }
          }
        }, 100);
        }, 500);
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log("error");
      },
    });
  } else {
    // const body = document.querySelector(".main_cart_btn");
    // body.dispatchEvent(new Event("click"));
    // $(".main_cart_btn").trigger("click");
    // setTimeout(function () {
    //   getUpdatedCart();
    // }, 1000);
    // var getProducid =  $('input.custom_product_varaint_id').val();
    // console.log('fdsf'+getProducid)
    //   $.ajax({
    //     type: "POST",
    //     url: "/cart/add.js",
    //     data: { id: getProducid
    //           },
    //     dataType: "json",
    //     async: false,
    //     success: function (data) {
    //       console.log("data");
    //        const body = document.querySelector('.main_cart_btn');
    //          body.dispatchEvent(new Event('click'));
    //       setTimeout(function(){ getUpdatedCart(); },500 );
    //     },
    //     error: function (jqXHR, textStatus, errorThrown) {
    //       console.log("error");
    //     },
    //   });
  }
});
$(".hero__content__wrapper").click(function () {
  var get_url = $(this).parent().find(".custom_link").attr("href");
  if (typeof get_url === "undefined") {
    // ...
  } else {
    window.location.href = get_url;
  }
});

$(document).on("click", ".button_text.custom_btn_trig", function (e) {
  e.preventDefault();
  e.stopPropagation();
  var checkClass = $(this).hasClass("active");
  var $this = $(this);
  if (!checkClass) {
    $(this).text("ADDED");
    setTimeout(function () {
      $this.text("REMOVE");
    }, 500);
  } else {
    $(this).text("ADD");
  }
  $(this).toggleClass("active");
  var get_actove = $(".button_text.custom_btn_trig.active").length;
  if (get_actove > 0) {
    $(".btn_wrap").addClass("active");
    $(".btn_wrap.add_on_wrapp").show();
    if (get_actove < 2) {
      $(".add_arwpppp").html(`Add ${get_actove} Product to Cart`);
    } else {
      $(".add_arwpppp").html(`Add ${get_actove} Products to Cart`);
    }
    $(".total_items_add_on .total_numbers_upsell").html(get_actove);
    $(".total_items_add_on").hide();
    $(".custom_main_cart").addClass("active_upsell");
  } else {
    $(".btn_wrap").removeClass("active");
    $(".add_arwpppp").html(`Add Any Product`);
    $(".total_items_add_on").hide();
    // $(".btn_wrap.add_on_wrapp").hide();
    $(".custom_main_cart").removeClass("active_upsell");
  }
  $(".button_text.custom_btn_trig.active").each(function () {
    $(this).parent().find(".upsell_sssss").addClass("custom_trigger");
  });
});

// jsonObj = [];
// $(document).on("click", ".active_upsell", function (e) {
//   setTimeout(function () {
//     $(".custom_btn_trig.active").each(function () {
//       var total_ids = $(this).attr("data-id");
//       // alert(total_ids);
//       item2 = {};
//       item2["id"] = parseInt(total_ids);
//       item2["quantity"] = 1;

//       jsonObj.push(item2);
//     });

//     $.ajax({
//       type: "POST",
//       url: "/cart/add.js",
//       data: { items: jsonObj },
//       dataType: "json",
//       success: function () {
//         //$(".main_cart_btn").trigger('click');
//         // const body = document.querySelector('.main_cart_btn');
//         // body.dispatchEvent(new Event('click'));
//       },
//     });
//   }, 500);
// });

jsonObj = [];
$(document).on("click", ".btn_wrap.add_on_wrapp.active", function (e) {
  $("div#mymodal_add_on").hide();
  $("body").removeClass("add_on_popup_active");
  $(".custom_btn_trig.active").each(function () {
    var total_ids = $(this).attr("data-id");
    // alert(total_ids);
    if (total_ids != "" && total_ids != null && total_ids != undefined) {
      item2 = {};
      item2["id"] = parseInt(total_ids);
      item2["quantity"] = 1;
      jsonObj.push(item2);
    }
  });
  console.log(jsonObj);
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { items: jsonObj },
    dataType: "json",
    success: function (data) {
      console.log(data);
      var cart = data;
      //getUpdatedCart();
      $(".product__submit__buttons .main_cart_btn").trigger("click");
      setTimeout(function () {
       document.dispatchEvent(
            new CustomEvent("theme:cart:reload", { bubbles: true })
          );
      }, 1000);
      console.log("cart-data :- " + cart);
      jsonObj = [];
    },
    error: function (error) {
      console.log(error);
      alert(error.responseJSON.message + "\n" + error.responseJSON.description);
    },
  });
});

$("body").on("click", ".cart__items__remove", function (e) {
  e.preventDefault();
  // var id = $(this).attr("data-id");
  // console.log("id:-" + id);
  // if (!id) {
  //   document.dispatchEvent(
  //     new CustomEvent("theme:cart:reload", { bubbles: true })
  //   );

  //   //getUpdatedCart();
  //   console.log("updated successfully...yaah");

  //   return false;
  // }

  // var $btn = $(this);
  // $btn.prop("disabled", true);

  // jQuery.ajax({
  //   type: "POST",
  //   url: "/cart/change.js",
  //   data: { id: id, quantity: 0 },
  //   dataType: "json",
  //   success: function (data) {
  //     document.dispatchEvent(
  //       new CustomEvent("theme:cart:reload", { bubbles: true })
  //     );
  //   },
  //   error: function (error) {
  //     console.log(error);
  //     alert(error.responseJSON.message + "\n" + error.responseJSON.description);
  //   },
  //   complete: function () {
  //     $btn.prop("disabled", false); // Re-enable button
  //   },
  // });

  var line = $(this).attr("data-line");
  console.log("line: " + line);
  var $btn = $(this);
  $btn.prop("disabled", true);
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      line: parseInt(line),
      quantity: 0,
    },
    dataType: "json",
    success: function (data) {
      document.dispatchEvent(
        new CustomEvent("theme:cart:reload", { bubbles: true })
      );
    },
    error: function (error) {
      console.log(error);
      alert(error.responseJSON.message + "\n" + error.responseJSON.description);
    },
    complete: function () {
      $btn.prop("disabled", false);
    },
  });
});

$(document).on("click", ".quantity__button", function (e) {
  e.preventDefault();
  var $this = $(this);
  var id = $(this).attr("data-id");
  var quantity = $this
    .parents(".cart__items__row")
    .find(".quantity__input-jtpl")
    .val();
  console.log(
    $this.hasClass("quantity__button--minus") +
      "======" +
      $this.hasClass("quantity__button--plus")
  );
  if (quantity == 0) {
    //do nothing
    quantity = parseInt(quantity);
  } else {
    if ($this.hasClass("quantity__button--minus")) {
      quantity = parseInt(quantity) - parseInt(1);
    } else if ($this.hasClass("quantity__button--plus")) {
      quantity = parseInt(quantity) + parseInt(1);
    }
  }

  if ($(".custom_quantity_enable").length > 0) {
    var res = 0;
    jQuery(".custom_quantity_enable").each(function () {
      var data_val = jQuery(this).find("input").val();
      res += parseInt(data_val);
    });
    var main_val = res;
    jQuery(".gift-product-disabled input").val(main_val);
  }

  //$this.parents(".cart__items__row").find(".quantity__input-jtpl").val(quantity);
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: { id: id, quantity: quantity },
    dataType: "json",
    success: function (data) {
      getUpdatedCart();
    },
    error: function (error) {
      console.log(error);
      //alert(error.responseJSON.message+"\n"+error.responseJSON.description);
    },
  });
   setTimeout(function(){
     console.log('plus minus clicked')
      document.dispatchEvent(
        new CustomEvent("theme:cart:reload", { bubbles: true })
      );
  },4500);
});

$(document).on("keyup change", ".quantity__input-jtpl", function (e) {
  e.preventDefault();
  var $this = $(this);
  var id = $(this).attr("data-id");
  var quantity = parseInt($this.val());
  if ($(".custom_quantity_enable").length > 0) {
    var res = 0;
    jQuery(".custom_quantity_enable").each(function () {
      var data_val = jQuery(this).find("input").val();
      res += parseInt(data_val);
    });
    var main_val = res;
    jQuery(".gift-product-disabled input").val(main_val);
  }

  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: { id: id, quantity: quantity },
    dataType: "json",
    success: function (data) {
      // setTimeout(function () {
      getUpdatedCart();
      //  }, 500);
    },
    error: function (error) {
      console.log(error);
      // alert(error.responseJSON.message+"\n"+error.responseJSON.description);
    },
  });
});

function getProductTags(product_handle) {
  // alert(product_handle);
  var tags = "";
  $.ajax({
    url: "/products/" + product_handle + "/?view=tag-jtpl",
    type: "GET",
    dataType: "html",
  }).done(function (data) {
    console.log(data);
    tags = data;
    console.log("tags data" + tags);
    return tags;
  });

  // jQuery.get('/product/'+product_handle, function(response){
  //   console.log(response);
  //   tags = $(response).find(".product-section").attr("data-tags");
  // });
  //return tags;
}
function getUpdatedCart() {
  $(".cart__items__row:first-child .item--loadbar").attr(
    "style",
    "display:block;"
  );
  jQuery.getJSON("/cart.js", function (cart) {
    if (cart) {
      console.log("Cart ———————————— ↓");
      console.log(cart);
      var items = cart.items;
      console.log("cart", items);
      console.log("items.length" + items.length);
      if (items.length > 0) {
        var myCart = "";
        items.forEach(function (item, index) {
          console.log("cart item", item.id);
          var cls = "";
          // var tags = getProductTags(item.handle);

          var tags = getProductTags;
          console.log("tag type: " + typeof tags);
          if (tags != "" && tags != undefined) {
            console.log(tags + "---tagsss");
            // if (tags.indexOf("gift_product") > -1) {
            //   cls += "gift-product-disabled";
            // }
            // if (tags.indexOf("free_gwp") > -1) {
            //   cls += "custom_quantity_enable";
            // }
          }
          // var tags = item.product.tags;

          var myCart1 = `<div class="cart__items__row" data-cart-item=""><div class="item--loadbar" data-item-loadbar="" style="display: none;">&nbsp;</div> 
            <div class="cart__items__grid" data-item=""> <a href="/cart/change?line=${index}&amp;quantity=0" class="cart__items__remove cart-content_remove-jtpl" data-id="${
              item.id
            }"
            data-line="${index}" data-remove-key="${
            item.key
          }" tabindex="0"> <span class="cart__remove__icon"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-bin" viewBox="0 0 11 14"><path d="M10 2v10a2 2 0 01-2 2H3a2 2 0 01-2-2V2h9zM9 3H2v9a1 1 0 00.883.993L3 13h5a1 1 0 00.993-.883L9 12V3z"></path><path d="M10.5 2a.5.5 0 110 1H.5a.5.5 0 010-1h10zm-3-2a.5.5 0 010 1h-4a.5.5 0 010-1h4z"></path></svg></span> <span class="cart__remove badge"> Remove</span> </a>  
            <div class="cart__items__image"> <a href="${item.url}?variant=${
            item.id
          }"> <img class="cart__items__img" src="${item.image}" alt="${
            item.product_title
          }"> </a> </div> 
            <div class="cart__items__title"> <p> <a href="${item.url}?variant=${
            item.id
          }">  ${item.product_title} </a>  </p> 
            <div class="cart__items__meta" ${item.variant_title != null ? '': ' style="display: none"'} > <p class="small">${
              item.variant_title
            }</p> </div> </div> 
            <div class="cart__items__price"> <p class="line__price"> $${
              item.price / 100
            }</p></div>
            <div class="cart__items__quantity"${item.product_type == "Gift" ? ' style="display: none"': ''}><div class=" ${cls} quantity__wrapper " data-quantity-selector><button data-id="${
            item.id
          }" class="quantity__button quantity__button-jtpl quantity__button--minus " data-decrease-quantity type="button">−</button>
            <label for="updates_${
              item.key
            }" class="visually-hidden">Quantity</label>
            <input data-quantity-input="" data-update-cart="${
              item.key
            }"  data-id="${
            item.id
          }" class="quantity__input quantity__input-jtpl" type="number" min="0" id="updates_${
            item.key
          }" name="updates[]" value="${item.quantity}">
            <button data-id="${
              item.id
            }" class="quantity__button quantity__button-jtpl  quantity__button--plus " data-increase-quantity="" type="button">+</button> </div></div> 
            <div class="cart__items__total">$${
              item.price / 100
            }</div></div></div>`;
          //console.log(myCart1);
          myCart += myCart1;
        });
        $(".myCartNew").html(
          '<div data-cart-form data-cart-loading> <div data-line-items><div class="cart__items">' +
            myCart +
            "</div></div></div>"
        );
        document.dispatchEvent(
          new CustomEvent("theme:cart:change", {
            detail: { cart: cart },
            bubbles: !0,
          })
        );
        setTimeout(function () {
          if ($("nav#drawer-cart").hasClass("drawer--visible")) {
            //do nothing
          } else {
            $(
              '.navlink.navlink--cart[data-drawer-toggle="drawer-cart"]'
            ).trigger("click");
          }
          $(".drawer__bottom").removeClass("cart--hidden");
        }, 500);
      } else {
        var mycart1 = `<div class="errors" data-form-errors="" style="display: none; box-sizing: border-box;" tabindex="0" aria-live="assertive" role="alert"></div>
    <style>
  .errors{
   display: none !important;
  }
</style>
    <div class="" data-cart-empty="">
<div class="cart__empty align--middle-center">
  <div class="wrapper">
    <p class="h4--body m0">Your cart is empty.</p>
    <div class="image-overlay" style="--overlay-opacity: 0.05;"></div>
  </div>
</div>
<a href="/collections/all" class="cart__circle__wrapper">
  <div class="cart__circle">
    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-cart" viewBox="0 0 25 25"><path d="M5.058 23a2 2 0 104.001-.001A2 2 0 005.058 23zm12.079 0c0 1.104.896 2 2 2s1.942-.896 1.942-2-.838-2-1.942-2-2 .896-2 2zM0 1a1 1 0 001 1h1.078l.894 3.341L5.058 13c0 .072.034.134.042.204l-1.018 4.58A.997.997 0 005.058 19h16.71a1 1 0 000-2H6.306l.458-2.061c.1.017.19.061.294.061h12.31c1.104 0 1.712-.218 2.244-1.5l3.248-6.964C25.423 4.75 24.186 4 23.079 4H5.058c-.157 0-.292.054-.438.088L3.844.772A1 1 0 002.87 0H1a1 1 0 00-1 1zm5.098 5H22.93l-3.192 6.798c-.038.086-.07.147-.094.19-.067.006-.113.012-.277.012H7.058v-.198l-.038-.195L5.098 6z"></path></svg>
  </div>
  <p class="cart__continue__link">
    Continue browsing
  </p>
</a>
      </div>`;
        $(".myCartNew").html(mycart1);
        document.dispatchEvent(
          new CustomEvent("theme:cart:change", {
            detail: { cart: cart },
            bubbles: !0,
          })
        );
      }
    } else {
      var mycart1 = `<div class="errors" data-form-errors="" style="display: none; box-sizing: border-box;" tabindex="0" aria-live="assertive" role="alert"></div>
    <style>
  .errors{
   display: none !important;
  }
</style>
    <div class="" data-cart-empty="">
<div class="cart__empty align--middle-center">
  <div class="wrapper">
    <p class="h4--body m0">Your cart is empty.</p>
    <div class="image-overlay" style="--overlay-opacity: 0.05;"></div>
  </div>
</div>
<a href="/collections/all" class="cart__circle__wrapper">
  <div class="cart__circle">
    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-cart" viewBox="0 0 25 25"><path d="M5.058 23a2 2 0 104.001-.001A2 2 0 005.058 23zm12.079 0c0 1.104.896 2 2 2s1.942-.896 1.942-2-.838-2-1.942-2-2 .896-2 2zM0 1a1 1 0 001 1h1.078l.894 3.341L5.058 13c0 .072.034.134.042.204l-1.018 4.58A.997.997 0 005.058 19h16.71a1 1 0 000-2H6.306l.458-2.061c.1.017.19.061.294.061h12.31c1.104 0 1.712-.218 2.244-1.5l3.248-6.964C25.423 4.75 24.186 4 23.079 4H5.058c-.157 0-.292.054-.438.088L3.844.772A1 1 0 002.87 0H1a1 1 0 00-1 1zm5.098 5H22.93l-3.192 6.798c-.038.086-.07.147-.094.19-.067.006-.113.012-.277.012H7.058v-.198l-.038-.195L5.098 6z"></path></svg>
  </div>
  <p class="cart__continue__link">
    Continue browsing
  </p>
</a>
      </div>`;
      $(".myCartNew").html(mycart1);
    }
  });
  $(".cart__items__row:first-child .item--loadbar").attr(
    "style",
    "display:none;"
  );
  return false;
}

$(document).on("mouseover", ".add_on_quick_view", function () {
  $(this)
    .parents(".tooltip-wrapper")
    .find(".tooltip-content")
    .css("display", "block");
});
$(document).on("mouseout", ".add_on_quick_view", function () {
  $(this)
    .parents(".tooltip-wrapper")
    .find(".tooltip-content")
    .css("display", "none");
});

if ($(window).width() <= 768) {
  $(document).on("click", ".add_on_quick_view", function () {
    $(this)
      .parents(".tooltip-wrapper")
      .find(".tooltip-content")
      .css("display", "block");
  });

  window.addEventListener("click", function (e) {
    $(this)
      .parents(".tooltip-wrapper")
      .find(".tooltip-content")
      .css("display", "none");
  });
}

$(document).ready(function () {
  var cartCheckInterval = setInterval(function () {
    // Check if cart has no items
    if ($(".cart__items").length === 0) {
      var $cartEmptyElement = $(".myCartNew [data-cart-empty]");

      // If the empty cart element is found
      if ($cartEmptyElement.length > 0) {
        $cartEmptyElement
          .removeClass("cart--hidden")
          .addClass("cart-has-items");

        console.log("Updated length: " + $(".cart--hidden").length);

        clearInterval(cartCheckInterval);
      }
    }
  }, 100);

  $(".block_type--Megamenu")
    .parents(".header__dropdown__wrapper")
    .addClass("custom-20-megamenu-cls");
  $(".block_type--Megamenu")
    .parents(".header__dropdown")
    .addClass("custom-20-megamenu-dropdown-cls");

  // Swatch Js Start

  function convertToSlug(Text) {
    return Text.toLowerCase()
      .replace(/ /g, "-")
      .replace(/[^\w-]+/g, "");
  }

  $(".swatch .swatch-element input").change(function () {
    var optionValue = $(this).val();
    $(this)
      .closest(".swatch")
      .find(`.swatch-element input`)
      .removeAttr("checked");
    $(this)
      .closest(".swatch")
      .find(`.swatch-element input[value="${optionValue}"]`)
      .attr("checked", "");
    var colorComb = [];
    $(".swatch").each(function (index) {
      var selectedColor = $(`.swatch[data-option-index="${index}"]`)
        .find(".swatch-element input[checked]")
        .val();
      colorComb.push(selectedColor);
    });

    if (colorComb.length == 1) {
      var getVal = colorComb[0];
      var getData = convertToSlug(getVal);
      var getPID = $("#getID-" + getData).val();
      var imgSrc = $("#getID-" + getData).attr("img-url");
      var productHandle = $("#getID-" + getData).attr("data-handle");
      $("#" + productHandle).attr("data-id", getPID);
      $("#" + productHandle)
        .parents("upsell-product")
        .find(".upsell__image .upsell__image__inner")
        .attr("src", imgSrc);
      console.log(getPID);
    }

    if (colorComb.length == 2) {
      var getVal = colorComb[0] + "-" + colorComb[1];
      var getData = convertToSlug(getVal);
      var getPID = $("#getID-" + getData).val();
      var imgSrc = $("#getID-" + getData).attr("img-url");
      var productHandle = $("#getID-" + getData).attr("data-handle");
      $("#" + productHandle).attr("data-id", getPID);
      $("#" + productHandle)
        .parents("upsell-product")
        .find(".upsell__image .upsell__image__inner")
        .attr("src", imgSrc);
      console.log(getPID);
    }

    if (colorComb.length == 3) {
      var getVal = colorComb[0] + "-" + colorComb[1] + "-" + colorComb[2];
      var getData = convertToSlug(getVal);
      var getPID = $("#getID-" + getData).val();
      var imgSrc = $("#getID-" + getData).attr("img-url");
      var productHandle = $("#getID-" + getData).attr("data-handle");
      $("#" + productHandle).attr("data-id", getPID);
      $("#" + productHandle)
        .parents("upsell-product")
        .find(".upsell__image .upsell__image__inner")
        .attr("src", imgSrc);
      console.log(getPID);
    }
  });

  // Swatch Js End

  // Add-on Sibling Swatch Js Start

  $(document).on(
    "click",
    ".first_content_wrap .upsell__holder .siblings__link",
    function (e) {
      e.preventDefault();
      var dataQty = $(this).attr("data-qty");
      var prodQty = $(this).parents(".upsell__holder").attr("product-qty");
      if (dataQty < 1 || prodQty < 1) {
        $(this)
          .parents(".upsell__holder")
          .find(".custom_btn_trig")
          .text("SOLD OUT");
        $(this)
          .parents(".upsell__holder")
          .find(".custom_btn_trig")
          .attr("disabled", true);
      } else {
        $(this).parents(".upsell__holder").find(".custom_btn_trig").text("ADD");
        $(this)
          .parents(".upsell__holder")
          .find(".custom_btn_trig")
          .attr("disabled", false);
      }
      $(this)
        .parents(".upsell__holder")
        .find(".siblings__link")
        .attr("aria-current", "false");
      $(this).attr("aria-current", "true");
      var getPID = $(this).attr("product-id");
      $(this)
        .parents(".upsell__holder")
        .find(".upsell_button_wrap .custom_btn_trig")
        .attr("data-id", getPID);
      var imgSrc = $(this).find(".background-size-cover").attr("original-size");
      $(this)
        .parents(".upsell__holder")
        .find(".upsell__image__inner")
        .attr("src", imgSrc);
    }
  );

  $(document).on(
    "mouseover",
    ".first_content_wrap .upsell__holder .siblings__link",
    function (e) {
      e.preventDefault();
      var colorName = $(this).attr("data-swapper-hover");
      $(this)
        .parents(".upsell__holder")
        .find("span[data-swapper-target]")
        .text(colorName);
    }
  );

  $(document).on(
    "mouseout",
    ".first_content_wrap .upsell__holder .siblings__link",
    function (e) {
      e.preventDefault();
      var colorName = $(this)
        .parents(".upsell__holder")
        .find(".siblings__link[aria-current='true']")
        .attr("data-swapper-hover");
      $(this)
        .parents(".upsell__holder")
        .find("span[data-swapper-target]")
        .text(colorName);
    }
  );

  $(".upsell__holder").each(function () {
    var dataQty = $(this)
      .find(".siblings__link:first[aria-current='true']")
      .attr("data-qty");
    var prodQty = $(this).attr("product-qty");
    if (dataQty < 1 || prodQty < 1) {
      $(this).find(".custom_btn_trig").text("SOLD OUT");
      $(this).find(".custom_btn_trig").attr("disabled", true);
    }
    $(this).find(".siblings__link:first").attr("aria-current", "true");
    var prodId = $(this).find(".siblings__link:first").attr("product-id");
    $(this)
      .find(".upsell_button_wrap .custom_btn_trig")
      .attr("data-id", prodId);
    var imgSrc = $(this)
      .find(".siblings__link:first")
      .find(".background-size-cover")
      .attr("original-size");
    $(this).find(".upsell__image__inner").attr("src", imgSrc);
  });

  $(document).on("click", ".customize_bluejay", function () {
    $(".upsell__holder").each(function () {
      var dataQty = $(this)
        .find(".siblings__link:first[aria-current='true']")
        .attr("data-qty");
      var prodQty = $(this).attr("product-qty");
      if (dataQty < 1 || prodQty < 1) {
        $(this).find(".custom_btn_trig").text("SOLD OUT");
        $(this).find(".custom_btn_trig").attr("disabled", true);
      }
    });
  });
  // Add-on Sibling Swatch Js End
  $(document).on("click", ".upsell__image", function (e) {
    e.preventDefault();
    var imgSrc = $(this).find(".upsell__image__inner").attr("src");
    $(".add-on-zoom-image-main").css("display", "flex");
    $(".add-on-zoom-image").attr("src", imgSrc);
  });

  $(document).on("click", ".add-on-zoom-image-main", function (e) {
    $(this).hide();
  });

  // $(document).mouseup(function(e)
  // {
  //     var container = $(".add-on-zoom-image-main");
  //     // if the target of the click isn't the container nor a descendant of the container
  //     if (!container.is(e.target) && container.has(e.target).length === 0)
  //     {
  //         container.hide();
  //     }
  // });
});
$("body").on(
  "click",
  ".select-popout__list li.select-popout__item",
  function () {
    //alert();
    var getTextonload = $(
      ".custom_main_cart span[data-add-to-cart-text]"
    ).text();
    console.log(getTextonload);
    if (getTextonload == "Sold Out") {
    // if (getTextonload != "Add to Cart") {
      $(".custom_main_wrapper").show();
      $("a.klaviyo-bis-trigger.custom_main_cart").show();
    } else {
      $(".custom_main_wrapper").hide();
      $("a.klaviyo-bis-trigger.custom_main_cart").hide();
    }
    var getTextonload1 = $(".main_cart_btn span[data-add-to-cart-text]").text();
    console.log(getTextonload1);
    // if (getTextonload1 != "Add to Cart") {
    if (getTextonload1 == "Sold Out") {
      // alert(1)
      $("button.custom_main_cart").attr("disabled", "disabled");
      $(".custom_main_wrapper").show();
      $("a.klaviyo-bis-trigger.custom_main_cart").show();
    } else {
      // alert(2)
      $("button.custom_main_cart").removeAttr("disabled", "disabled");
      $("a.klaviyo-bis-trigger.custom_main_cart").hide();
      $(".custom_main_wrapper").hide();
    }
    var getText = $(this).find("span").text().trim();
    console.log(getText);
    var productText = $(".custom_product_specific_text").text();
    var getColor = $(
      "a.siblings__link.custom_prdouc_swatch[aria-current=true]"
    ).attr("data-swapper-hover");
    console.log(getColor);
    var getCombo = getColor + " / " + getText;
    $(".custom_product_options option").each(function () {
      var Optiontext = $(this).text().trim();
      console.log(Optiontext + "===" + getCombo);
      if (Optiontext == getCombo) {
        var getSelectedId = $(this).val();
        //alert(getSelectedId)
        $(".custom_product_varaint_id").val(getSelectedId);
        var getVarinattext = $(this).attr("variant-text");
        if (getVarinattext != "") {
          $("span.custom_varaint_specific_text").text(getVarinattext);
        } else {
          $("span.custom_varaint_specific_text").text(productText);
        }
      } else {
        console.log("no");
      }
    });
  }
);

// show hide Klaviyo btn if variant is out of stock when switching variant
  document.addEventListener("theme:variant:change", function (event) {
    setTimeout(function () {
      var btnText = $(".custom_main_cart span[data-add-to-cart-text]").text().trim();
      var btnText2 = $(".main_cart_btn span[data-add-to-cart-text]").text().trim();

      console.log("btnText:", btnText);
      console.log("btnText2:", btnText2);

      if (btnText === "Sold Out" || btnText2 === "Sold Out") {
        $(".custom_main_wrapper").show();
        $("a.klaviyo-bis-trigger.custom_main_cart").show();
        $("button.custom_main_cart").attr("disabled", "disabled");
      } else {
        $(".custom_main_wrapper").hide();
        $("a.klaviyo-bis-trigger.custom_main_cart").hide();
        $("button.custom_main_cart").removeAttr("disabled");
      }
    }, 150);
  });

var getOnloadText = $("li.select-popout__item.select-popout__item--current")
  .text()
  .trim();
var productOnloadText = $(".custom_product_specific_text").text();
var getOnloadColor = $(
  "a.siblings__link.custom_prdouc_swatch[aria-current=true]"
).attr("data-swapper-hover");
var getonloadCombo = getOnloadColor + " / " + getOnloadText;
$(".custom_product_options option").each(function () {
  var OptionOnloadtext = $(this).text().trim();
  if (OptionOnloadtext == getonloadCombo) {
    var getOnloadVarinattext = $(this).attr("variant-text");
    if (getOnloadVarinattext != "") {
      $("span.custom_varaint_specific_text").text(getOnloadVarinattext);
    } else {
      $("span.custom_varaint_specific_text").text(productOnloadText);
    }
  } else {
    console.log("no");
  }
});
// show hide notify if out of stock strat

var getTextonload = $(".custom_main_cart span[data-add-to-cart-text]").text();
//alert(getTextonload);
// if (getTextonload != "Add to Cart") {
if (getTextonload == "Sold Out") {
  // alert(1)
  $(".custom_main_wrapper").show();
  $("a.klaviyo-bis-trigger.custom_main_cart").show();
} else {
  // alert(2)

  $(".custom_main_wrapper").hide();
  $("a.klaviyo-bis-trigger.custom_main_cart").hide();
}
var getTextonload1 = $(".main_cart_btn span[data-add-to-cart-text]").text();
console.log(getTextonload1);
// if (getTextonload1 != "Add to Cart") {
if (getTextonload1 == "Sold Out") {
  // alert(1)
  $(".custom_main_wrapper").show();
  $("a.klaviyo-bis-trigger.custom_main_cart").show();
} else {
  // alert(2)
  $("a.klaviyo-bis-trigger.custom_main_cart").hide();
  $(".custom_main_wrapper").hide();
}
// show hide notify if out of stock end

// notify me click
$("body").on("click", "a.klaviyo-bis-trigger.custom_main_cart", function (e) {
  e.preventDefault();
  e.stopPropagation();
  $("iframe#klaviyo-bis-iframe").show();
  $("body").addClass("is-notify-active");
});
$("body").on("click", ".custom_notify_button_wrapper", function (e) {
  e.preventDefault();
  //alert()
  $("iframe#klaviyo-bis-iframe").hide();
  $("body").removeClass("is-notify-active");
  $("body").css("overflow", "unset");
});

window.addEventListener("mouseup", function (event) {
  var pol = document.getElementById("klaviyo-bis-iframe");
  if (event.target != pol && event.target.parentNode != pol) {
    $("iframe#klaviyo-bis-iframe").hide();
    $("body").removeClass("is-notify-active");
    $("body").css("overflow", "unset");
  }
});
var siblingsElements = document.querySelectorAll(".product__page__siblings");

siblingsElements.forEach(function (siblingsElement) {
  var anchorTags = siblingsElement.querySelectorAll("a");

  anchorTags.forEach(function (anchorTag) {
    anchorTag.addEventListener("click", function () {
      var upsellElement = anchorTag.closest(".upsell");

      if (upsellElement) {
        var activeElement = upsellElement.querySelector(
          ".upsell_button_wrap .custom_btn_trig.active"
        );

        if (activeElement) {
          activeElement.classList.remove("active");
        }
      }
    });
  });

  $(".select-popout__item").click(function () {
    setTimeout(function () {
      console.log("yes clicked");
      $(".custom_main_cart").removeAttr("disabled", "disabled");
    }, 100);
    setTimeout(function () {
      console.log("yes clicked");
      $(".custom_main_cart").removeAttr("disabled", "disabled");
    }, 2000);
  });

  $(document).on("click", ".medtafields_image", function () {
    setTimeout(function () {
      var varianturl = window.location.href;
      console.log(varianturl);
      var urlParams = new URLSearchParams(window.location.search);
      var variant = urlParams.get("variant");
      if (variant != "") {
        $(".custom_product_varaint_id").val(variant);
      }
    }, 600);
  });
});
function cart_items() {
  var product_var = $(".free_product").val();
  var getLength = $(".cart__items").find(".cstm_free_product").length;

  if (getLength > 0) {
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: {
        id: product_var,
        quantity: getLength,
      },
      dataType: "json",
      async: false,
      success: function (data) {},
      error: function (jqXHR, textStatus, errorThrown) {
        console.log("error");
      },
    });
  }
}
$('.add_arwpppp').click(function () {
  console.log('add to popup click');
  setTimeout(function(){
      document.dispatchEvent(
        new CustomEvent("theme:cart:reload", { bubbles: true })
      );
  },3500)
})
setInterval(function () {
  cart_items();
}, 6000);
